import { LTText } from '@lambdatestincprivate/lt-components';
import { relativeTime } from '../format';

/**
 * run.yaml carries no user — the byline credits the producer instead:
 * "kane-cli recorded this run 2 days ago".
 */
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export function Byline(_ref) {
  var run = _ref.run;
  var name = run.producerName;
  var started = relativeTime(run.startedAt);
  var ended = relativeTime(run.endedAt);
  var boldName = name ? /*#__PURE__*/_jsx(LTText, {
    as: "span",
    variant: LTText.TextVariant.SUBHEADER_BOLD,
    color: "var(--lt-text-primary)",
    children: name
  }) : null;
  var sentence;
  if (run.lifecycle === 'running') {
    sentence = /*#__PURE__*/_jsxs(_Fragment, {
      children: [boldName !== null && boldName !== void 0 ? boldName : 'Recording', " started this run", started ? " ".concat(started) : '', " \xB7 still running"]
    });
  } else if (run.lifecycle === 'aborted') {
    sentence = /*#__PURE__*/_jsxs(_Fragment, {
      children: [boldName !== null && boldName !== void 0 ? boldName : 'Recorded', " aborted this run", ended ? " ".concat(ended) : started ? " ".concat(started) : '']
    });
  } else {
    sentence = /*#__PURE__*/_jsxs(_Fragment, {
      children: [boldName ? /*#__PURE__*/_jsxs(_Fragment, {
        children: [boldName, " recorded this run"]
      }) : 'Recorded', ended ? " ".concat(ended) : started ? " ".concat(started) : '']
    });
  }
  return /*#__PURE__*/_jsx(LTText, {
    variant: LTText.TextVariant.SUBHEADER_REGULAR,
    color: "#636C76",
    children: sentence
  });
}